import { get } from 'svelte/store';
import { event } from './stores.js';

import moment from 'moment-timezone';

//import momentRange from 'moment-range';
//const range = momentRange.extendMoment(moment);

export const now = () => {
	// todo: accommodate utcDiff
	return moment().utc();
};

export const getEpoch = (dt) => {
	if (!dt) dt = now();
	return dt.unix();
};

export const showDate = (dt, fmt) => {
	if (!dt) dt = now();
	if (!fmt) fmt = 'DD MMM YY [at] HH:mm';
	const e = get(event);
	const tz = e.setup.timeZone;
	return moment.utc(dt).tz(tz).format(fmt);
};

export const ago = (dt) => {
	if (!dt) dt = now();
	return moment.utc(dt).fromNow();
};

export const showEpoch = (e, fmt) => {
	const dt = moment.unix(e).utc();
	return showDate(dt, fmt);
};

export const fromUTC = (dt,tz) => {
	if (tz) {
		return moment.utc(dt).tz(tz);
	} else {
		return moment.utc(dt).local();
	}
};

export const toUTC = (dt,tz) => {
	if (tz) {
		return moment.tz(dt,tz).utc();
	} else {
		return moment(dt).local().utc();
	}
};

export const iso = (dt,tz) => {
	if (dt) {
		if (tz) {
			return moment.utc(dt).tz(tz).toISOString();
		} else {
			return moment.utc(dt).local().toISOString();
		}
	} else {
		return moment().utc().toISOString();
	}
};

export const isPast = (m) => {
	let t = now();
	return m.isBefore(t) ? true : false;
};

export const isPastDay = (m) => {
	let t = now();
	const ev = get(event);
	const tz = ev.setup.timeZone;
	return m.tz(tz).isBefore(t.tz(tz), "day") ? true : false;
};

export const isToday = (m,e) => {
	let now = e ? moment.utc(e * 1000) : moment().utc();
	const ev = get(event);
	const tz = ev.setup.timeZone;
	return m.tz(tz).isSame(now.tz(tz), "day") ? true : false;
};

export const isSameDay = (m1,m2) => {
	const ev = get(event);
	const tz = ev.setup.timeZone;
	return m1.tz(tz).isSame(m2.tz(tz), "day") ? true : false;
};

export const enumerateDaysBetweenDates = (startDate, endDate) => {
	const ev = get(event);
	const tz = ev.setup.timeZone;
	let dates = [];
	let es = fromUTC(startDate,tz);
	let ee = fromUTC(endDate,tz);
	let d = es;
	while (d.isSameOrBefore(ee)) {
		dates.push(d.toISOString());
		d.add(1, 'days');
	}
	return dates;
};

export const roundToNearest = (date, duration, method) => {
    return moment(Math[method]((+date) / (+duration)) * (+duration)); 
};
